module.exports = __webpack_public_path__ + "img/image-cigarette-pack.950c491.png";